import React, { FC } from 'react'
import TimeSelect, { createTimeOptions } from '@ui/TimeSelector'
import { Moment } from 'moment-timezone'
import { DateUtil } from '@utils/dateUtil'
import { IUIButtonProps } from '@ui'
import css from './settings.module.scss'

type PropsT = {
  showDate?: boolean
  timezone: string
  timeFrom: DateUtil
  timeTo: DateUtil
  timeList: DateUtil[]
  disableFrom?: boolean
  disableTo?: boolean
  disabledFromOptions?: number[]
  disabledToOptions?: number[]
  buttonProps?: IUIButtonProps
  dateProps?: IUIDateTimeProps
  onChange: (value: string, isFrom: boolean) => void
  isNotBookDesk?: boolean
}

export interface IUIDateTimeProps {
  className?: string
  style?: any
}

const TimeSelector: FC<PropsT> = ({
  showDate,
  timezone,
  timeFrom,
  timeList,
  timeTo,
  disableFrom = false,
  disableTo = false,
  onChange,
  dateProps = {},
  buttonProps,
  disabledFromOptions = [],
  disabledToOptions = [],
  isNotBookDesk,
}) => {
  dateProps.className = 'mr-2 ' + (dateProps?.className || '')
  return (
    <div className={isNotBookDesk ? css.time_selector_desk : css.time_selector}>
      <div className="mr-2 inline-block">
        From {showDate && <span {...dateProps}>{timeFrom.format('MMM dd')}</span>}
        <TimeSelect
          timezone={timezone}
          value={timeFrom.toISOString()}
          moments={timeList.filter((_, i) => i !== timeList.length - 1)}
          onChange={(value) => onChange(value, true)}
          buttonProps={buttonProps}
          disabledOptionsIndexes={disabledFromOptions}
          disabled={disableFrom}
        />
      </div>
      <div className={isNotBookDesk ? css.to_date : css.to_date_default}>
        To {showDate && <span {...dateProps}>{timeTo.format('MMM dd')}</span>}
        <TimeSelect
          timezone={timezone}
          value={timeTo.toISOString()}
          buttonProps={buttonProps}
          moments={timeList}
          onChange={(value) => onChange(value, false)}
          disabledOptionsIndexes={disabledToOptions}
          disabled={disableTo}
        />
      </div>
    </div>
  )
}

export default TimeSelector
